import store from '../index'

export function clearData() {
  store.dispatch('ClearUser');
  store.dispatch('ClearPermission');
}



// WEBPACK FOOTER //
// ./src/store/modules/clearData.js